// test1612
(1612 && 0);
